export default "__VITE_ASSET__DrZhC$g6__"